import GoldImage from "@/app/assets/images/digital-gold.png";
import SilverImage from "@/app/assets/images/digital-silver.png";
import { BullionItem } from "../interface/bullion";
import { DirectPaths } from "@/config/routes";

//
export const ICM_NAME_SHORT = "ICM"; // company short name.
export const ICM_NAME_FULL = "InCred Money"; // company long name.
export const ICM_ADVISORY = "icmAdvisory"; // advisory partner name.

// SOCIAL
export const ICM_BLOGS_URL = "https://incredmoney.com/blog";
export const INSTAGRAM = "https://www.instagram.com/incredmoney/";
export const FACEBOOK = "https://www.facebook.com/incredmoney/";
export const X_TWITTER = "https://x.com/incredmoney/";
export const LINKEDIN = "https://www.linkedin.com/company/incredmoney/";
export const YOUTUBE = "https://www.youtube.com/@InCredMoney";

// OTHERS
export const SEBI = "https://www.sebi.gov.in/";
export const NSE = "https://www.nseindia.com/";
export const BSE = "https://www.bseindia.com/";
export const CDSL = "https://www.cdslindia.com/";
export const ICM_PHN_1 = "+91 85918 71028";
export const ICM_PHN_2 = "+91 89282 50817";
export const ICM_MAIL = "connect@incredmoney.com";
export const ICM_MAIL_SUPPORT = "support@incredmoney.com";
export const ICM_ZOOM = "https://scheduler.zoom.us/investment-expert/book-consultation";
export const ICM_NEWS_LINK = "https://www.incredmoney.com/blog/market-news/";
export const archana_conceptpr = "archana@conceptpr.com";
export const huda_conceptpr = "huda@conceptpr.com";
export const priyansh_saxena_incredmoney = "priyansh.saxena@incredmoney.com";
export const vipin_kumar_incredmoney = "vipin.kumar@incredmoney.com";
export const vijay_kuppa_incredmoney = "vijay.kuppa@incredmoney.com";

export const routeBasedLogoUrl = [
    {
        host: `${process.env.ICM_URL}${DirectPaths.BROKING}`,
        logoUrl: `${process.env.ICM_BROKING_LOGO_URL}`,
    },
    {
        host: `${process.env.ICM_URL}${DirectPaths.GLOBAL}`,
        logoUrl: `${process.env.ICM_GLOBAL_LOGO_URL}`,
    },
    {
        host: `${process.env.ICM_URL}${DirectPaths.UNLISTED_SHARES}`,
        logoUrl: `${process.env.ICM_UE_LOGO_URL}`,
    },
    {
        host: `${process.env.ICM_URL}${DirectPaths.ALTS}${DirectPaths.BULLION + DirectPaths.GOLD}`,
        logoUrl: `${process.env.ICM_BULLION_LOGO_URL}`,
    },
    {
        host: `${process.env.ICM_URL}${DirectPaths.ALTS}${DirectPaths.BULLION + DirectPaths.SILVER}`,
        logoUrl: `${process.env.ICM_BULLION_LOGO_URL}`,
    },
    {
        host: `${process.env.ICM_URL}${DirectPaths.ALTS}${DirectPaths.FD}`,
        logoUrl: `${process.env.ICM_FD_LOGO_URL}`,
    },
];

//icm-refer-benifit
export const ICM_REFER_AMAZON_BENEFIT = 200;
export const ICM_REFER_BENEFIT = 0.25;
export const ICM_REFERRER_AMAZON_BENEFIT = 750;
export const ICM_REFERRER_BENEFIT = 1;

// Data
export const TESTIMONIALS = [
    {
        said: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest",
        by: "Lakshminarayanan Iyer",
    },
    {
        said: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        by: "Nidhi Agarwal",
    },
];

export const INNEWS = [
    {
        said: "Oyo expands leadership team.",
        by: "The Economic Times",
    },
    {
        said: "Oyo expands leadership team.",
        by: "The Economic Times",
    },
    {
        said: "Oyo expands leadership team.",
        by: "The Economic Times",
    },
];

export const AVG_TRANSACTIONS_VALUE = 10000;
export const MAX_EARNING = 10750;
export const AMZ_VOUCHER = 750;
export const FIRST_TRANSACTION_AMT = 200;
export const UPI_MAX_AMT = 100000;

/** Product codes excluded from sitemap and server-side crawlable links (e.g. ZEP01 - Zepto Ltd) */
export const UNLISTED_EXCLUDE_FROM_CRAWLABLE_LINKS: string[] = ["ZEP01", "SP02", "ICFS", "INC01"];

export const UE_METADATA = {
    title: "Buy & Sell Unlisted Shares, Pre - IPO Shares online | InCred Money",
    keywords: "Invest in Unlisted Shares, Stocks & Pre IPO companies online | InCred Money",
    description:
        "Securely buy/sell unlisted shares through our verified platform. Invest in Unlisted Stocks or Sell Unlisted Shares Online at good price in India with InCred Money",
    ogUrl: process.env.ICM_URL,
    ogTitle: "Buy & Sell Unlisted Shares, Pre - IPO Shares online | InCred Money",
    ogDescription:
        "Securely buy/sell unlisted shares through our verified platform. Invest in Unlisted Stocks or Sell Unlisted Shares Online at good price in India with InCred Money",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_URL}/unlisted-shares` },
};

export const US_STOCKS_METADATA = {
    title: "Invest in US Stock Markets from India | InCred Money",
    keywords: "Invest in US Stock Markets from India | InCred Money",
    description:
        "Invest in US stock markets from India with InCred Money. Access global markets online, explore top US companies, diversify your portfolio, and trade seamlessly.",
    ogUrl: `${process.env.ICM_GLOBAL_URL}${DirectPaths.US_STOCKS}`,
    ogTitle: "Invest in US Stock Markets from India | InCred Money",
    ogDescription:
        "Invest in US stock markets from India with InCred Money. Access global markets online, explore top US companies, diversify your portfolio, and trade seamlessly.",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_GLOBAL_URL}${DirectPaths.US_STOCKS}` },
};

export const US_ETFS_METADATA = {
    title: "Invest in US ETF Markets from India | InCred Money",
    keywords: "Invest in US ETF Markets from India | InCred Money",
    description:
        "Invest in US ETF markets from India with InCred Money. Access global markets online, explore top US companies, diversify your portfolio, and trade seamlessly.",
    ogUrl: `${process.env.ICM_GLOBAL_URL}${DirectPaths.US_ETFS}`,
    ogTitle: "Invest in US ETF Markets from India | InCred Money",
    ogDescription:
        "Invest in US ETF markets from India with InCred Money. Access global markets online, explore top US companies, diversify your portfolio, and trade seamlessly.",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_GLOBAL_URL}${DirectPaths.US_ETFS}` },
};

export const GLOBAL_STOCKS_METADATA = {
    title: "Invest in US Stock Markets from India | InCred Money",
    keywords: "Invest in US Stock Markets from India | InCred Money",
    description:
        "Invest in US stock markets from India with InCred Money. Access global markets online, explore top US companies, diversify your portfolio, and trade seamlessly.",
    ogUrl: `${process.env.ICM_GLOBAL_URL}${DirectPaths.US_STOCKS}`,
    ogTitle: "Invest in US Stock Markets from India | InCred Money",
    ogDescription:
        "Invest in US stock markets from India with InCred Money. Access global markets online, explore top US companies, diversify your portfolio, and trade seamlessly.",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_GLOBAL_URL}` },
};

export const INDIAN_STOCKS_METADATA = {
    title: "Invest in Indian Stocks - Check Live Price | InCred Money",
    keywords: "Invest in Indian Stocks - Check Live Price | InCred Money",
    description:
        "Get the complete list of Indian stocks online, explore top Indian companies, diversify your portfolio globally, and check live prices, key financials, and similar stocks on InCred Money.",
    ogUrl: `${process.env.ICM_URL}${DirectPaths.GLOBAL}`,
    ogTitle: "Invest in Indian Stocks - Check Live Price| InCred Money",
    ogDescription:
        "Get the complete list of Indian stocks online, explore top Indian companies, diversify your portfolio globally, and check live prices, key financials, and similar stocks on InCred Money.",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_URL}${DirectPaths.BROKING}` },
};

export const BONDS_METADATA = {
    title: "InCred Money Bonds - 10-12% Returns p.a. on Corporate Bonds",
    keywords: "InCred Money Bonds - 10-12% Returns p.a. on Corporate Bonds",
    description: "InCred Money Bonds - 10-12% Returns p.a. on Corporate Bonds",
    ogUrl: process.env.ICM_BONDS_URL,
    ogTitle: "InCred Money Bonds - 10-12% Returns p.a. on Corporate Bonds",
    ogDescription: "InCred Money Bonds - 10-12% Returns p.a. on Corporate Bonds",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_BONDS_URL}` },
};

export const PROFILE_METADATA = {
    title: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | InCred Money",
    keywords: "Invest in Unlisted Shares, Stocks & Pre IPO companies online | InCred Money",
    description:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with InCred Money for higher returns. Buy and sell online today!",
    ogUrl: process.env.ICM_URL,
    ogTitle: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | InCred Money",
    ogDescription:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with InCred Money for higher returns. Buy and sell online today!",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const FD_METADATA = {
    title: "Fixed Deposits - Invest in Best FDs Online | InCred Money",
    keywords: "Fixed Deposits - Invest in Best FDs Online | InCred Money",
    description:
        "Compare and book the best FDs on the InCred Money app. Start with just ₹5,000. 100% Paperless. Instant Booking in 5 minutes.",
    ogUrl: process.env.ICM_FD_URL + DirectPaths.FD_POSTFIX_PATH,
    ogTitle:
        "Compare and book the best FDs on the InCred Money app. Start with just ₹5,000. 100% Paperless. Instant Booking in 5 minutes.",
    ogDescription:
        "Compare and book the best FDs on the InCred Money app. Start with just ₹5,000. 100% Paperless. Instant Booking in 5 minutes.",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_FD_URL + DirectPaths.FD_POSTFIX_PATH}` },
};

export const Portfolio_METADATA = {
    title: "InCredMoney Portfolio | InCred Money",
    keywords: "InCredMoney Portfolio | InCred Money",
    description: "Portfolio page of ICM",
    ogUrl: `${process.env.ICM_URL}/portfolio`,
    ogTitle: "Portfolio page of ICM",
    ogDescription: "Portfolio page of ICM",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
    alternates: { canonical: `${process.env.ICM_URL}/portfolio` },
};

export const REFER_METADATA = {
    title: "InCred Money Referral - Refer Your Friends & Earn Rewards",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description: "Earn exciting rewards by referring your friends and family to InCred Money",
    ogUrl: process.env.ICM_URL,
    ogTitle: "InCred Money Referral - Refer Your Friends & Earn Rewards",
    ogDescription: "Earn exciting rewards by referring your friends and family to InCred Money",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const LOGIN_MEATADATA = {
    title: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | InCred Money",
    keywords: "Invest in Unlisted Shares, Stocks & Pre IPO companies online | InCred Money",
    description:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with InCred Money for higher returns. Buy and sell online today!",
    ogUrl: process.env.ICM_URL,
    ogTitle: "Buy & Sell Unlisted Shares, Stocks & Pre IPO Shares Online | InCred Money",
    ogDescription:
        "Invest in unlisted shares and Pre-IPO companies like OYO, NSE, Utkarsh and Swiggy with InCred Money for higher returns. Buy and sell online today!",
    ogImgUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const NEUTRAL_METADATA = {
    title: " Invest in Pre-IPO Shares, Fixed Deposits & Bonds | InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with InCred Money",
    itempropName: "Alternate Investment Platform - Best Passive Income Investment",
    itempropDescription:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with InCred Money",
    ogUrl: process.env.ICM_URL,
    ogTitle: "Invest in Pre-IPO Shares, Fixed Deposits & Bonds | InCred Money",
    ogDescription:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with InCred Money",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const DISCLAIMER_METADATA = {
    title: "Legal Disclaimer - InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description: "Disclaimer. Make informed financial decisions.",
    itempropDescription: "",
    ogDescription: "Disclaimer. Make informed financial decisions.",
    ogTitle: "Legal Disclaimer - InCred Money",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const POLICY_METADATA = {
    title: "Policy Center | InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with InCred Money",
    itempropDescription: "",
    ogDescription:
        "Diversify your investment portfolio with unlisted shares, FDs, and bonds for higher returns. Get started with InCred Money",
    ogTitle: "Legal Policy - InCred Money",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const CONTACT_METADATA = {
    title: "Contact Us - InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Contact us for any inquiries, questions, or assistance you need. Our team is here to help you with prompt and reliable support. Reach out to us today!",
    ogTitle: "Contact Us - InCred Money",
    ogDescription:
        "Contact us for any inquiries, questions, or assistance you need. Our team is here to help you with prompt and reliable support. Reach out to us today!",
    ogUrl: process.env.ICM_URL,
    itempropDescription:
        "Contact us for any inquiries, questions, or assistance you need. Our team is here to help you with prompt and reliable support. Reach out to us today!",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const PRIVACY_POLICY_METADATA = {
    title: "Privacy Policy - InCred Money",
    ogTitle: "Privacy Policy - InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Explore InCredMoney's Privacy Policy and start your journey in alternative assets with confidence. Discover how we prioritize your data security.",
    itempropDescription:
        "Explore InCredMoney's Privacy Policy and start your journey in alternative assets with confidence. Discover how we prioritize your data security.",
    ogDescription:
        "Learn how we collect, use, and protect your personal information in our privacy policy.",
    ogUrl: process.env.ICM_URL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const TERMS_OF_USE_METADATA = {
    title: "Terms and Conditions - InCred Money",
    ogTitle: "Terms and Conditions - InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Explore our T&C page for guidelines for your use of our services. Learn more to ensure a transparent and reliable experience with us.",
    itempropDescription:
        "Explore our T&C page for guidelines for your use of our services. Learn more to ensure a transparent and reliable experience with us.",
    ogDescription:
        "Explore our T&C page for guidelines for your use of our services. Learn more to ensure a transparent and reliable experience with us.",
    ogUrl: process.env.ICM_URL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const ABOUT_METADATA = {
    title: "About InCred Money | Democratising Alternate Investments",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Discover how InCred Money, the premier alternate asset investment platform, empowers investors to diversify their portfolios.",
    ogTitle: "About InCred Money | Democratising Alternate Investments",
    ogDescription:
        "Discover how InCred Money, the premier alternate asset investment platform, empowers investors to diversify their portfolios.",
    ogUrl: process.env.ICM_URL,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const ANNOUNCEMENT_METADATA = {
    title: "InCred Money Revolutionizing Retail Wealth-Tech with Orowealth Acquisition",
    ogTitle: "InCred Money Revolutionizing Retail Wealth-Tech with Orowealth Acquisition",
    description:
        "Experience InCred Money - Revolutionizing Retail Wealth-Tech with Orowealth. Diverse investments, personalized guidance, and robust technology platform. Join now!",
    ogDescription:
        "Experience InCred Money - Revolutionizing Retail Wealth-Tech with Orowealth. Diverse investments, personalized guidance, and robust technology platform. Join now!",
    ogUrl: `${process.env.ICM_URL}/announcement`,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const INVESTOR_RELATIONS_METADATA = {
    title: "Investor Relations - InCred Money",
    keywords: "Alternate Investment Platform - Best Passive Income Investment",
    description:
        "Get detailed insights into InCred Money's financial performance, corporate governance, and investor information. Access reports, presentations and key updates.",
    ogTitle: "Investor Relations - InCred Money",
    ogDescription:
        "Get detailed insights into InCred Money's financial performance, corporate governance, and investor information. Access reports, presentations and key updates.",
    ogUrl: process.env.ICM_URL,
    itempropDescription:
        "Get detailed insights into InCred Money's financial performance, corporate governance, and investor information. Access reports, presentations and key updates.",
    ogImgUrl: `${process.env.APP_IMAGES_PATH}icm-white-logo.webp?timestamp=${Date.now()}`,
};

export const CALCULATOR_METADATA = {
    title: "FD Interest Rate Calculators - InCred Money",
    ogTitle: "FD Interest Rate Calculators - InCred Money",
    description:
        "Enter your principal amount, tenure, and interest rate to predict how much you'll get back at the end.",
    itempropDescription:
        "Enter your principal amount, tenure, and interest rate to predict how much you'll get back at the end.",
    ogDescription:
        "Learn how we collect, use, and protect your personal information in our privacy policy.",
    ogUrl: `${process.env.APP_BASE_URL}/`,
    ogImgUrl: `${process.env.APP_IMAGES_PATH}incred-money-1.webp`,
};

// PDF Links
export const CMLURL =
    "https://marketing.incredmoney.com/Assets/Documents/Client+Master+Lists+%28CML%29.pdf";
export const DEMAT_URL = "https://marketing.incredmoney.com/Assets/webAssets/ICM_DEMAT.pdf";
export const ICM_DEEPLINK_URL = "https://incredmoney.app.link/3HGFpMW8nQb";
export const INVESTOR_REPORT_URL =
    "https://marketing.incredmoney.com/Assets/webAssets/Annual Report-23-24-Alpha Fintech.pdf";
export const INVESTOR_NOTICE_URL =
    "https://marketing.incredmoney.com/Assets/webAssets/IFS/Notice of Annual General Meeting-23-24.pdf";
export const INVESTOR_REPORT_URL2 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Annual+Report-+FY+24-25.pdf";
export const INVESTOR_NOTICE_URL2 =
    "https://marketing.incredmoney.com/Assets/webAssets/Notice+of+Annual+General+Meeting+FY+24-25.pdf";
export const INVESTOR_ORDER_URL =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+booth+admission+order+-+CTC.pdf";
export const INVESTOR_MEETING_URL =
    "https://marketing.incredmoney.com/Assets/webAssets/Form+CAA-2+-+Notice+of+the+NCLT+convened+meeting+of+ESH.pdf";
export const INVESTOR_MEETING_URL1 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+-+Notice+to+unsecured+creditors.pdf";
export const INVESTOR_MEETING_URL2 =
    "https://marketing.incredmoney.com/Assets/webAssets/Form+CAA+2+%E2%80%93+Newspaper+Publication+for+Meeting.pdf";
export const INVESTOR_MEETING_URL3 =
    "https://marketing.incredmoney.com/Assets/webAssets/Scrutinizers+Report+-+Equity+Shareholders+-+Novemeber+3%2C+2025.pdf";
export const INVESTOR_TAB_URL =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Consolidated+2022-23.pdf";
export const INVESTOR_TAB_URL1 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Consolidated+2023-24.pdf";
export const INVESTOR_TAB_URL2 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Consolidated+2024-25.pdf";
export const INVESTOR_TAB_URL3 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Standalone+2022-23.pdf";
export const INVESTOR_TAB_URL4 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Standalone+2023-24.pdf";
export const INVESTOR_TAB_URL5 =
    "https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+Private+Limited+Standalone+2024-25.pdf";

export const SIGNUP_QUESTIONS = [
    {
        Title: "Tell us what you’re looking for",
        question: "What brings you here?",
        options: ["Digital Gold & Silver", "Fixed deposits", "Bonds", "Loans"],
        qid: "3f18eefa-1c3e-4290-bfca-828d1041c6a6",
    },
    {
        Title: "Tell us what you’re looking for",
        question: "How much do you plan to invest?",
        options: [
            "Below 50K",
            "50K - 1L",
            "1L - 5L",
            "5L - 10L",
            "10L - 25L",
            "Above 25L",
            "I'm not sure",
        ],
        qid: "651160ceb590c72cedcdda41",
    },
    {
        Title: "Where did you hear about us?",
        question: "Select all that apply",
        options: [
            "Facebook / Instagram",
            "LinkedIn",
            "Youtube",
            "Akshat Shrivastav",
            "Friends / Family",
            "News / TV",
            "Other",
        ],
        qid: "651160b1b590c72cedcdda3f",
    },
];

export const graphColors: string[] = [
    "#4F6FFF",
    "#283A97",
    "#87BDDB",
    "#1594F5",
    "#4F6FFF",
    "#18619A",
];

export const subDomains = {
    ICU_REDIRECT: String(process.env.ICU_URL?.split("https://")[1]?.trim()),
    NEUTRAL: String(process.env.ICM_URL?.split("https://")[1]?.trim()),
    STOCKS: String(process.env.ICM_STOCKS_URL?.split("https://")[1]?.trim()),
    PAYMENT: String(process.env.ICM_PAYMENT_URL?.split("https://")[1]?.trim()),
    BONDS: String(process.env.ICM_BONDS_URL?.split("https://")[1]?.trim()),
    FD: String(
        String(process.env.ICM_FD_POST_URL + DirectPaths.FD)
            ?.split("https://")[1]
            ?.trim(),
    ),
    FD_INDEXED_1: String(process.env.ICM_FD_INDEXED_1)?.split("https://")[1]?.trim(),
    BULLION: String(
        String(process.env.ICM_BULLION_POST_URL + DirectPaths.BULLION)
            ?.split("https://")[1]
            ?.trim(),
    ),
    GLOBAL: String(process.env.ICM_GLOBAL_POST_URL?.split("https://")[1]?.trim()),
    ALTS: String(process.env.ICM_UE_POST_URL?.split("https://")[1]?.trim()),
    // HOME: "home.icm.com:3000",
    // DEV: "dev.icm.com:3000",
};

export const apiBasedSubDomains = {
    GENERIC: String(process.env.API_BASE_URL?.trim()),
    NEUTRAL: String(process.env.API_BASE_URL?.trim()),
    STOCKS: String(process.env.API_STOCKS_URL?.trim()),
    PAYMENT: String(process.env.API_STOCKS_URL?.trim()), // same stocks API for payment.
    BONDS: String(process.env.API_BONDS_URL?.trim()),
    FD: String(process.env.API_FD_URL?.trim()),
    BULLION: String(process.env.API_BASE_URL?.trim()),
    GLOBAL: String(process.env.API_BASE_URL?.trim()),
    ALTS: String(process.env.API_STOCKS_URL?.trim()),
};

export const STOCK_METADATA: { [key: string]: { title: string; description: string } } = {
    "oravel-stays-ltd-(oyo-rooms)": {
        title: "Buy Oyo Rooms Unlisted Shares Online (ORAVEL STAYS LIMITED)",
        description:
            "Buy & Sell Oyo Rooms Unlisted Shares With InCred Money. Explore detailed financials, market insights, and seamless transaction processes on InCred Money.",
    },
    "national-stock-exchange-ltd-(nse)": {
        title: "Buy NSE India Unlisted Shares Online",
        description:
            "Trade NSE India unlisted shares effortlessly with InCred Money. Access financial details, market insights, and smooth transactions.",
    },
    "national-e-repository-limited-(nerl)": {
        title: "NeRL Unlisted Shares | National e-Repository Ltd",
        description:
            "Check NeRL unlisted share price, valuation updates & company performance. Invest in National e-Repository Ltd unlisted shares with ease from InCred Money.",
    },
    "chennai-super-kings-cricket-ltd-(csk)": {
        title: "Buy CSK Unlisted Pre-IPO Shares",
        description:
            "Buy & Sell CSK Unlisted Shares on InCred Money. Get real-time and insights on CSK Pre-IPO Share Prices & historical financial performance.",
    },
    "sbi-funds-management-ltd-(sbi-amc)": {
        title: "Buy SBI Funds Management Unlisted Shares",
        description:
            "Trade SBI Funds Management unlisted shares with InCred Money. Access financial details, market insights, and smooth transactions with InCred Money.",
    },
    "ncdex-ltd": {
        title: "NCDEX Unlisted Shares Price - Buy & Sell Online with InCred Money",
        description:
            "Get the latest news and updates on NCDEX unlisted share price & track historical financial performance, market data and price charts with InCred Money.",
    },
    "spray-engineering-devices-limited": {
        title: "Spray Engineering Devices Unlisted Shares Price - Buy & Sell Online",
        description:
            "Trade Spray Engineering Devices unlisted shares effortlessly with InCred Money. Access financial details, market insights, and smooth transactions.",
    },
    "parag-parikh-financial-advisory-services-ltd-(ppfas)": {
        title: "Parag Parikh Financial Unlisted Shares - Buy/Sell",
        description:
            "Buy/Sell Parag Parikh Financial Unlisted Shares With InCred. Explore detailed financials, market insights, and seamless transaction processes on InCred.",
    },
    "orbis-financial-corporation-ltd": {
        title: "Orbis Financial Unlisted Shares Price - Buy/Sell",
        description:
            "Buy/Sell Orbis Financial Unlisted Shares With InCred. Explore detailed financials, market insights, and seamless transaction processes on InCred.",
    },
    "apollo-green-energy-ltd": {
        title: "Buy Apollo Green Energy Unlisted Shares",
        description:
            "Apollo Green Unlisted Shares Alternative Investment Made Easy. Explore market insights, financial data, and seamless transactions with InCred Money.",
    },
    "indian-potash-ltd": {
        title: "Indian Potash Unlisted Shares - Buy & Sell Online",
        description:
            "Buy/Sell Indian Potash Unlisted Shares With InCred. Explore detailed financials, market insights, and seamless transaction processes on InCred.",
    },
    "hdb-financial-services-ltd": {
        title: "Buy & Sell HDB Financial Services Unlisted Shares Online",
        description:
            "Buy & Sell HDB Financial Services unlisted shares for potential growth. Explore market trends, financials, and opportunities before making informed decisions.",
    },
    "hella-infra-market-ltd": {
        title: "Buy Sell Hella Infra Market Unlisted Shares",
        description:
            "Buy Sell Hella Infra Market unlisted shares on InCred Money. Check the latest Infra Market unlisted share price, valuation trends, and pre-IPO insights.",
    },
    "cochin-international-airport-ltd-(cial)": {
        title: "Buy & Sell Cochin International Airport Unlisted Shares at Best Price",
        description:
            "Buy & Sell Cochin International Airport Ltd unlisted shares. Analyze financials and potential growth opportunities before investing.",
    },
    "care-health-insurance-ltd-(religare)": {
        title: "Buy & Sell Care Health Insurance Ltd Unlisted Shares Price & Details",
        description:
            "Buy & Sell Care Health Insurance unlisted shares. A simple way to invest before the IPO with InCred Money and grow your wealth.",
    },
    "imagine-marketing-ltd-(boat)": {
        title: "Buy & Sell Imagine Marketing Ltd (BoAt) - Unlisted Shres",
        description:
            "Buy & Sell Imagine Marketing Ltd (boAt) unlisted shares, get price trends, market potential, and key investment insights.",
    },
    "tata-capital-ltd": {
        title: "Buy & Sell Tata Capital Ltd Unlisted Shares",
        description:
            "Buy & Sell Tata Capital Ltd unlisted shares, get pricing, performance, and investment opportunities in the private market.",
    },
    "pharmeasy-(api-holdings-ltd)": {
        title: "Pharmeasy (API Holdings Ltd) Unlisted Shares",
        description:
            "Buy Pharmeasy unlisted shares at InCred Money. Check latest Pharmeasy unlisted share price, valuation, financial updates & pre-IPO investment details",
    },
    "metropolitan-stock-exchange-of-india-ltd": {
        title: "Buy MSEI Unlisted Shares",
        description:
            "Check MSEI Unlisted Share Price, valuation trends & company details. Buy & Sell Metropolitan Stock Exchange (MESI) Unlisted Shares on InCred Money.",
    },
    "sunday-proptech-ltd-(oyo-assets)": {
        title: "Sunday PropTech Pre-IPO Shares (OYO Assets)",
        description:
            "Invest in Sunday PropTech unlisted shares with InCred Money. Track the latest unlisted share price and access in-depth financial analysis. Buy Now!",
    },
    "hero-fincorp-limited": {
        title: "Buy & Sell Hero Fincorp Ltd: Buy Unlisted Shares",
        description:
            "Buy & Sell Hero Fincorp unlisted shares on InCred Money. Access pre-IPO opportunities and diversify your portfolio. Get started today!",
    },
    "signify-innovations-india-ltd-(previously-philips-lighting)": {
        title: "Signify Innovations India Ltd (Philips Lighting) Unlisted Shares",
        description:
            "Invest in Signify Innovations India Ltd (Philips Lighting) unlisted shares through InCred Money. Unlock new financial possibilities and grow your portfolio!",
    },
};

export const US_STOCK_METADATA: { [key: string]: { title: string; description: string } } = {
    /* "": {
        title: "",
        description: "",
    }, */
}; // common metadata set in layout file.

export const BULLION_METADATA: { [key: string]: { title: string; description: string } } = {
    "24-karat-gold": {
        title: "24 Karat Gold | InCred Money",
        description: "24 Karat Gold | InCred Money",
    },
    "22-karat-gold": {
        title: "22 Karat Gold | InCred Money",
        description: "22 Karat Gold | InCred Money",
    },
    "digital-gold": {
        title: "22 Karat Gold | InCred Money",
        description: "22 Karat Gold | InCred Money",
    },
    "pure-silver": {
        title: "Buy Digital Silver Online | Pure Silver Investment from ₹10 | InCred Money",
        description:
            " Own pure 999 digital silver starting at ₹10. Securely stored in insured vaults. Buy, sell, or convert to physical silver anytime—flexible, affordable, and transparent.",
    },
};

export const CSK_ISIN = "INE852S01026";

export const TEST_NEWS_DATA_PLATFORM = [
    {
        order: 1,
        webLink:
            "https://www.medianews4u.com/playr-continues-its-partnership-with-ipl-franchise-csk-for-2025-global-merchandising/",
        deepLink:
            "https://www.medianews4u.com/playr-continues-its-partnership-with-ipl-franchise-csk-for-2025-global-merchandising/",
        heading: "MN4U Bureau",
        description:
            "playR continues its partnership with IPL franchise CSK for 2025 Global Merchandising",
        thumbnail: "https://assets.incredmoney.com/images/v2/webp/CSK.webp",
        publishDate: 1739471400000,
    },
    {
        order: 2,
        webLink:
            "https://www.news18.com/cricket/mi-csk-kkr-among-seven-ipl-franchises-submit-bids-to-buy-stake-in-the-hundred-report-9092980.html",
        deepLink:
            "https://www.news18.com/cricket/mi-csk-kkr-among-seven-ipl-franchises-submit-bids-to-buy-stake-in-the-hundred-report-9092980.html",
        heading: "news18.com",
        description:
            "MI, CSK, KKR Among Seven IPL Franchises Submit Bids to Buy Stake in The Hundred",
        thumbnail: "https://assets.incredmoney.com/images/v2/webp/CSK.webp\t",
        publishDate: 1729794600000,
    },
    {
        order: 3,
        webLink:
            "https://timesofindia.indiatimes.com/sports/cricket/ipl/top-stories/ipl-retention-csk-chennai-super-kings-ms-dhoni-uncapped-player-rule/articleshow/114842043.cms",
        deepLink:
            "https://timesofindia.indiatimes.com/sports/cricket/ipl/top-stories/ipl-retention-csk-chennai-super-kings-ms-dhoni-uncapped-player-rule/articleshow/114842043.cms",
        heading: "The Times of India",
        description: "How did CSK retain MS Dhoni for Rs. 4cr ?",
        thumbnail: "https://assets.incredmoney.com/images/v2/webp/CSK.webp",
        publishDate: 1730917800000,
    },
];

export const BullionData: BullionItem[] = [
    {
        image: GoldImage,
        name: "24K Digital Gold",
        desc: "99.5% Pure",
        minInvestment: 10,
        gram: "",
        GST: "3%",
    },
    {
        image: SilverImage,
        name: "Pure Digital Silver",
        desc: "99.5% Pure",
        minInvestment: 10,
        gram: "",
        GST: "3%",
    },
];

export enum ANNOUNCEMENT_TRIGGER_SCREENS {
    HomeScreen = "HomeScreen",
    ReferralScreen = "ReferralScreen",
    MldAssetsListing = "MldAssetsListing",
    BondsListing = "BondsListing",
    FDLandingScreen = "FDLandingScreen",
    UnlistedEquityScreen = "UnlistedEquityScreen",
    Profile = "Profile",
    UserKyc = "UserKyc",
    PortfolioScreen = "PortfolioScreen",
}

export const VAPID_KEY =
    "BLzBHq8p1AY1c13b0fEWyrL2O1pczF4sn4U7BN449afSO0gDiDK5bSg1gp_6_Cl3oajQSrGeC1f8HTYx305R2gI";
